// extracted by mini-css-extract-plugin
export default {"infoBoxContainer":"InfoBox_infoBoxContainer__6NVou","infoBoxTitle":"InfoBox_infoBoxTitle__x9L3G","infoBoxSeparator":"InfoBox_infoBoxSeparator__vfF6X"};